import { render, staticRenderFns } from "./PgaOfferEvaluationDetailsInternalProjectCreate.vue?vue&type=template&id=3915210a&"
import script from "./PgaOfferEvaluationDetailsInternalProjectCreate.vue?vue&type=script&lang=ts&"
export * from "./PgaOfferEvaluationDetailsInternalProjectCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3915210a')) {
      api.createRecord('3915210a', component.options)
    } else {
      api.reload('3915210a', component.options)
    }
    module.hot.accept("./PgaOfferEvaluationDetailsInternalProjectCreate.vue?vue&type=template&id=3915210a&", function () {
      api.rerender('3915210a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/feature/Offerte/OfferEvaluation/components/create/sub-components/PgaOfferEvaluationDetailsInternalProjectCreate.vue"
export default component.exports